import request from '@/utils/request'
export function submitReport(data) {
	return request.post('audit/submit', data)
}

export function submitReportDetail(params) {
	return request.get('audit/listDetail', {
		params
	})
}

export function submitReportDetailZ(params) {
	return request.get('expert-audit/applyDetail', {
		params
	})
}

export function reportList(params) {
	return request.get('expert-audit/applyList', {
		params
	})
}
export function applyReview(data) {
	return request.post('expert-audit/applyReview',data)
}

export function getReportDetail(params) {
	return request.get('expert-audit/reviewDetail', {
		params
	})
}
// 暂存
export function setCacheData(data) {
	return request.post('audit/storage',data)
}

// 获取暂存数据
export function getCacheData(params) {
	return request.get('audit/storage/detail', {
		params
	})
}